(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/router/assets/javascripts/tabs-loader.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/router/assets/javascripts/tabs-loader.js'); 
'use strict';

function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  Loader
} = svs.components.ReactLoader;
const {
  Button
} = svs.ui;
const {
  withGlobalEvent
} = svs.utils;
function getOffset(element) {
  const box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
class TabsLoader extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loadingContainer", React.createRef());
    _defineProperty(this, "onGlobalResize", () => {
      this.fixContainerHeight();
    });
    _defineProperty(this, "fixContainerHeight", () => {
      if (this.loadingContainer.current) {
        const offset = getOffset(this.loadingContainer.current);
        const desiredHeight = window.innerHeight - offset.top;
        this.loadingContainer.current.style.height = "".concat(desiredHeight, "px");
      }
    });
  }
  componentDidMount() {
    this.fixContainerHeight();
  }
  componentDidUpdate(prevProps) {
    if (['error', 'timeout'].some(prop => this.props[prop] !== prevProps[prop])) {
      this.fixContainerHeight();
    }
  }
  render() {
    const {
      error,
      timeout,
      retry
    } = this.props;
    if (error) {
      return React.createElement("div", {
        className: "f-center",
        "data-testid": "qa-marketplace-tabs-loader-errored"
      }, React.createElement("h1", null, "N\xE5gonting gick fel"), React.createElement("p", null, "Sidan du f\xF6rs\xF6kte n\xE5 kunde inte h\xE4mtas."), React.createElement(Button, {
        className: "qa-loader-retry",
        "data-testid": "qa-marketplace-tabs-loader-errored-button",
        focus: true,
        onClick: retry
      }, "F\xF6rs\xF6k igen"));
    }
    return React.createElement("div", {
      className: "marketplace-tabs-loader-container",
      "data-testid": "qa-marketplace-tabs-loader",
      ref: this.loadingContainer
    }, timeout ? React.createElement("div", {
      className: "marketplace-tabs-loader-container",
      ref: this.loadingContainer
    }, React.createElement("div", null, React.createElement("h1", null, "Det verkar ta l\xE5ng tid"), React.createElement("p", {
      className: "margin-bottom-2"
    }, "Vi forts\xE4tter att f\xF6rs\xF6ka h\xE4mta sidan."), React.createElement(Loader, {
      inverted: true
    }))) : React.createElement(Loader, {
      inverted: true
    }));
  }
}
_defineProperty(TabsLoader, "defaultProps", {
  error: null,
  retry: () => null,
  timeout: false
});
setGlobal('svs.marketplace.components.router.TabsLoader', withGlobalEvent('resize')(TabsLoader));
 })(window);